import { Button, ButtonGroup, Chat, kitText } from "@madhive/kit-ui";
import {
  AgentSessionServerError,
  UnauthenticatedError
} from "@madhive/mad-sdk";
import { AgentChatErrorProps } from "./types";

/**
 * `AgentChatError` is a component that displays an error message within the AI chat interface.
 * It provides options to reload the page, reload the session, or start a new session based on the error type.
 * @internal This component is intended for internal use within the AgentChat component and is not exported as part of the public API.
 */
export function AgentChatError({
  error,
  isCreatingSession,
  reloadSession,
  newSession
}: AgentChatErrorProps) {
  function reloadPage() {
    if (typeof window?.location?.reload === "function") {
      window.location.reload();
    }
  }

  const isUnauthenticated = error && error instanceof UnauthenticatedError;
  const isServerError = error && error instanceof AgentSessionServerError;
  return (
    <div className="kitPlus-agent-chat-error">
      <Chat.Message
        received
        bottomActions={
          <ButtonGroup justifyContent="start">
            {isUnauthenticated || isServerError ? (
              <Button
                onClick={reloadPage}
                variant="ghost"
                suffix="Refresh"
                size="small"
              >
                Reload Page
              </Button>
            ) : (
              <>
                {reloadSession ? (
                  <Button
                    onClick={reloadSession}
                    variant="ghost"
                    suffix="Refresh"
                    size="small"
                  >
                    Reload Session
                  </Button>
                ) : null}
                {newSession ? (
                  <Button
                    onClick={newSession}
                    variant="ghost"
                    suffix="Plus"
                    size="small"
                    isLoading={isCreatingSession}
                  >
                    New Session
                  </Button>
                ) : null}
              </>
            )}
          </ButtonGroup>
        }
      >
        <span css={kitText.color.error}>
          {error?.message || "An error occurred while processing your request."}
        </span>
      </Chat.Message>
    </div>
  );
}
